import { CompanyQuestionnaire } from "@/models/CompanyQuestionnaire";

export const CompanyQuestionnaireRequest = (argCompanyQuestionnaire) => {
  let companyQuestionnaire = argCompanyQuestionnaire.copy();

  if (!companyQuestionnaire.id) {
    delete companyQuestionnaire.id;
  }

  if (companyQuestionnaire.questionnaire) {
    companyQuestionnaire.questionnaire = companyQuestionnaire.questionnaire.id;
  }

  if (companyQuestionnaire.receivers) {
    companyQuestionnaire.receivers = companyQuestionnaire.receivers.map((r) => r.id);
  }

  return companyQuestionnaire;
};

export const CompanyQuestionnaireResponse = (response) => {
  if (!response || !response.data) {
    return null;
  }
  return new CompanyQuestionnaire(response.data);
};

export const CompanyQuestionnairesResponse = (response) => {
  if (!response || !response.data) {
    return [];
  }
  return response.data.map((q) => new CompanyQuestionnaire(q));
};
